/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import Wait from "@react/react-spectrum/Wait";
import SearchProgressBarCss from "./SearchProgressBar.css";
import { FormattedMessage } from "react-intl";
import { isCurrentDeviceMobile } from "dc-preview-utils/src/Utils/DeviceUtils";

class SearchProgressBarSmall extends React.Component {
  render() {
    const isDeviceMobile = isCurrentDeviceMobile();
    return (
      <div className={SearchProgressBarCss.Wait}>
        <Wait size="S" className={SearchProgressBarCss.WaitSpinner} />
        {isDeviceMobile ? null : (
          <FormattedMessage id="find.progressSmall">
            {label => <div className={SearchProgressBarCss.WaitText}>{label}</div>}
          </FormattedMessage>
        )}
      </div>
    );
  }
}

export { SearchProgressBarSmall };
